import { Box, Text, useColorMode } from "theme-ui";

const OptionList: React.FC<{
    options: string[];
    selected?: string | null;
    onSelect: (option: string) => void;
}> = ({ options, selected, onSelect }) => {
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "secondary" : "#dadada";
    return (
        <Box sx={{ p: 0 }}>
            {options.map(opt => (
                <Text
                    key={opt}
                    className="text-hover"
                    as="p"
                    sx={{
                        backgroundColor: selected === opt ? "rgba(141, 141, 141, 0.2)" : "transparent",
                        '&:hover': {
                            backgroundColor: colorMode === 'light' ? '#f5f5f5' : '#333333'
                        },
                        color: titleHeader,
                        cursor: "pointer",
                        padding: '10px'

                    }}
                    onClick={(e: any) => {
                        onSelect(opt)
                    }}
                >
                    {opt}
                </Text>
            ))}
        </Box>
    )
}

export default OptionList